module.exports = __webpack_public_path__ + "img/about-purple-cross.72b98163.png";